import React from 'react';
import * as analytics from '../../../services/analytics';

const GetQuotesButton = props => {
    const handleClick = () => {
        if (props.handler) {
            props.handler();
        }

        analytics.track('Clicked Get Your Quotes', {
            category: 'Landing Page',
            label: 'Adviser Section',
        });
    };

    let className = 'button';
    if (props.size === 'big') {
        className = 'big-button';
    }

    return (
        <button className={`${className} vouchedfor-brand landing-page`} onClick={handleClick}>
            Find the best adviser for me
        </button>
    );
};

export default GetQuotesButton;
